<div class="link-field-container">
  <div class="link-info">
    <mat-checkbox
      [checked]="possibleReference.isSelected"
      (change)="checkboxSelected(possibleReference)"
    ></mat-checkbox>
    {{ label }} ( {{ display | displayTranslation }})
  </div>
</div>
